import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageHealth(){
  var T=React.useContext(ThemeCtx).T;
  var _d=useState(null); var data=_d[0]; var setData=_d[1];
  var _e=useState(null); var err=_e[0]; var setErr=_e[1];
  useEffect(function(){api.get("/health").then(setData).catch(function(e){setErr(e.message);});}, []);
  return React.createElement(Card,null,
    React.createElement("div",{style:{fontSize:14,fontWeight:600,color:T.text,marginBottom:12}},"System Health"),
    err&&React.createElement("div",{style:{color:T.danger,fontSize:13}},err),
    data&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:8}},Object.entries(data).map(function(e){return React.createElement("div",{key:e[0],style:{display:"flex",gap:10,fontSize:13}},React.createElement("span",{style:{color:T.text3,minWidth:80}},e[0]),React.createElement("span",{style:{color:T.text}},String(e[1])));})),
    !data&&!err&&React.createElement("div",{style:{color:T.text3,fontSize:13}},"Loading...")
  );
}

